/**
 * Format an amount with the correct currency symbol and locale
 */
export const formatAmount = (amount: number, currency: string = 'EUR'): string => {
  const isUSD = currency.toUpperCase() === 'USD';
  const formatted = amount.toLocaleString(isUSD ? 'en-US' : 'de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return isUSD ? `$${formatted}` : `${formatted} €`;
};

/**
 * Get currency symbol
 */
export const getCurrencySymbol = (currency: string = 'EUR'): string => {
  return currency.toUpperCase() === 'USD' ? '$' : '€';
};
